import { Command } from 'commands/Commands';

export class ChangeAddressLine extends Command {
  type: string = 'ChangeAddressLine';
  priority: number = 100;
}
